import { render, staticRenderFns } from "./FundsTransfer.vue?vue&type=template&id=661458b4"
import script from "./FundsTransfer.vue?vue&type=script&lang=js"
export * from "./FundsTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports